import React from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Add auth header interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public
export const getCategories = (type) => api.get('/categories', { params: type ? { type } : {} });
export const getTours = (params) => api.get('/tours', { params });
export const getTour = (slug) => api.get(`/tours/${slug}`);
export const createReservation = (data) => api.post('/reservations', data);

// Admin
export const adminLogin = (data) => api.post('/admin/login', data);
export const getAdminStats = () => api.get('/admin/stats');
export const submitContact = (data) => api.post('/contact', data);
export const getAdminContactMessages = () => api.get('/admin/contact-messages');
export const markContactMessageRead = (id) => api.patch(`/admin/contact-messages/${id}/read`);
export const uploadFile = (category, file, onProgress) => {
  const form = new FormData();
  form.append('file', file);
  return api.post(`/admin/upload?category=${encodeURIComponent(category)}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
};
export const getAdminCategories = () => api.get('/admin/categories');
export const createCategory = (data) => api.post('/admin/categories', data);
export const updateCategory = (id, data) => api.put(`/admin/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/admin/categories/${id}`);
export const getAdminTours = () => api.get('/admin/tours');
export const createTour = (data) => api.post('/admin/tours', data);
export const updateTour = (id, data) => api.put(`/admin/tours/${id}`, data);
export const deleteTour = (id) => api.delete(`/admin/tours/${id}`);
export const getAdminReservations = () => api.get('/admin/reservations');
export const updateReservation = (id, data) => api.put(`/admin/reservations/${id}`, data);
export const seedData = () => api.post('/admin/seed');

// Settings
export const getSettings = () => api.get('/settings');
export const getAdminSettings = () => api.get('/admin/settings');
export const updateAdminSettings = (data) => api.put('/admin/settings', data);

// Levels
export const getLevels = () => api.get('/levels');
export const getAdminLevels = () => api.get('/admin/levels');
export const createLevel = (data) => api.post('/admin/levels', data);
export const updateLevel = (id, data) => api.put(`/admin/levels/${id}`, data);
export const deleteLevel = (id) => api.delete(`/admin/levels/${id}`);

// Blog
export const getBlogPosts = (limit = 20) => api.get('/blog', { params: { limit } });
export const getBlogPost = (slug) => api.get(`/blog/${slug}`);
export const getAdminBlogPosts = () => api.get('/admin/blog');
export const createBlogPost = (data) => api.post('/admin/blog', data);
export const updateBlogPost = (id, data) => api.put(`/admin/blog/${id}`, data);
export const deleteBlogPost = (id) => api.delete(`/admin/blog/${id}`);

// Blog Comments
export const getApprovedComments = (postSlug) => api.get(`/comments/${postSlug}`);
export const createComment = (data) => api.post('/comments', data);
export const getAdminComments = () => api.get('/admin/comments');
export const approveComment = (id) => api.patch(`/admin/comments/${id}/approve`);
export const deleteComment = (id) => api.delete(`/admin/comments/${id}`);

// Wishlist
export const sendWishlistEmail = (data) => api.post('/wishlist/email', data);

// Group inquiry
export const submitGroupInquiry = (data) => api.post('/group-inquiry', data);
export const getAdminGroupInquiries = () => api.get('/admin/group-inquiries');
export const markGroupInquiryRead = (id) => api.patch(`/admin/group-inquiries/${id}/read`);

// Special events
export const getAdminEvents = () => api.get('/admin/events');
export const createEvent = (data) => api.post('/admin/events', data);
export const updateEvent = (id, data) => api.put(`/admin/events/${id}`, data);
export const deleteEvent = (id) => api.delete(`/admin/events/${id}`);

export default api;
